module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-02.c503f1e8.png";